import React from "react"
import { createRoot } from "react-dom/client"
import App from "./App"
import Theme from "styles/Theme"
import { RecoilRoot } from "recoil"
import initSentry from "./sentry"

initSentry()
const root = createRoot(document.getElementById("root")!)
root.render(
  <Theme>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </Theme>
)
